module.exports = __webpack_public_path__ + "assets/img/akbank@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/akbank@2x.png
// module id = 125
// module chunks = 0